goog.provide("shadow.js.shim.module$src$svg$editor$editing$copy_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$editing$copy_svg");
shadow.js.shim.module$src$svg$editor$editing$copy_svg = shadow.js.nativeProvides["src/svg/editor/editing/copy.svg"] = shadow$bridge("src/svg/editor/editing/copy.svg");
module$shadow_js_shim_module$src$svg$editor$editing$copy_svg.default = shadow.js.shim.module$src$svg$editor$editing$copy_svg;
